const state = {
  user: null,
  token: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js